import { createAction, props } from '@ngrx/store';
import { QueryParams } from '../../modals/QueryParams';
import ThankyouNotes from '../../modals/ThankyouNotes';

export const thankYouNotesRequested = createAction(
  '[THANK_YOU_NOTES] ThankYouNotes Requested',
  props<{ params: QueryParams }>()
);

export const thankYouNotesLoaded = createAction(
  '[THANK_YOU_NOTES] ThankYouNotes Loaded',
  props<{ notes: ThankyouNotes[], hasNextPage: boolean }>()
);

export const thankYouNotesResetRequested = createAction(
  '[THANK_YOU_NOTES] ThankYouNotes Reset Requested'
);

export const thankYouNotesResetCompleted = createAction(
  '[THANK_YOU_NOTES] ThankYouNotes Reset Completed',
  props<{ notes: ThankyouNotes[], hasNextPage: boolean }>()
);

export const thankYouNotesLoadingError = createAction(
  '[THANK_YOU_NOTES] ThankYouNotes Api Call Error',
  props<{ errorMessage: string }>()
);
